module.exports = __webpack_public_path__ + "static/media/picture1.8f009f4b.png";